import { useState, useEffect } from "react";
import {
  getCurrentProfile,
  getVersionHistory,
  getGeneratedAttributes,
  type VoiceProfile,
  type VersionHistoryItem,
  type GeneratedAttributes,
} from "../../services/brand/brand-voice-service";

export interface BrandVoiceData {
  currentProfile: VoiceProfile | null;
  versionHistory: VersionHistoryItem[];
  generatedAttributes: GeneratedAttributes | null;
}

export function useBrandVoiceData() {
  const [data, setData] = useState<BrandVoiceData>({
    currentProfile: null,
    versionHistory: [],
    generatedAttributes: null,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = async () => {
    try {
      setIsLoading(true);
      setError(null);

      const [profileData, historyData, attributesData] = await Promise.all([
        getCurrentProfile(),
        getVersionHistory(),
        getGeneratedAttributes(),
      ]);

      setData({
        currentProfile: profileData,
        versionHistory: historyData,
        generatedAttributes: attributesData,
      });
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to load brand voice data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { data, isLoading, error, refresh, setData };
}